import { EnvironmentVariables } from '../../../constants/EnvironmentVariables';

export class MobileSecurityService {
  private checkForAntiTampering: boolean = true;
  private checkForRooting: boolean = EnvironmentVariables.Platform === 'android';
  private checkForJailbreak: boolean = EnvironmentVariables.Platform === 'ios';

  private IRootModule: any | undefined;
  private DiagnosticsModule: any | undefined;

  public constructor(options?: {
    checkForAntiTampering?: boolean | undefined;
    checkForRooting?: boolean | undefined;
    checkForJailbreak?: boolean | undefined;
  }) {
    this.checkForAntiTampering =
      options?.checkForAntiTampering === undefined
        ? this.checkForAntiTampering
        : options?.checkForAntiTampering;
    this.checkForRooting =
      options?.checkForRooting === undefined ? this.checkForRooting : options.checkForRooting;
    this.checkForJailbreak =
      options?.checkForJailbreak === undefined ? this.checkForJailbreak : options.checkForJailbreak;

    if (typeof window !== 'undefined') {
      if ((<any>window).cordova && (<any>window).cordova.plugins.IRoot) {
        this.IRootModule = (<any>window).cordova.plugins.IRoot;
      } else if ((<any>window).plugins && (<any>window).plugins.IRoot) {
        this.IRootModule = (<any>window).plugins.IRoot;
      } else if ((<any>window).IRoot) {
        this.IRootModule = (<any>window).IRoot;
      }

      if ((<any>window).cordova && (<any>window).cordova.plugins.diagnostic) {
        this.DiagnosticsModule = (<any>window).cordova.plugins.diagnostic;
      } else if ((<any>window).plugins && (<any>window).plugins.diagnostic) {
        this.DiagnosticsModule = (<any>window).plugins.diagnostic;
      } else if ((<any>window).diagnostic) {
        this.DiagnosticsModule = (<any>window).diagnostic;
      }
    }
  }

  private IRootModule_IsRooted = async (): Promise<boolean> => {
    /*IOS & android*/
    const promise = new Promise<boolean>((resolve, reject) => {
      if (!this.IRootModule) {
        console.error('IRootModule_IsRooted - Module not found.');
        resolve(false);
      } else {
        this.IRootModule.isRooted(
          (res: boolean) => {
            if (res === true) {
              console.error('IRootModule_IsRooted - Rooting/Jailbreak detected');
            }
            resolve(res);
          },
          (err: string) => {
            console.error(`IRootModule_IsRooted - ${err || ''}`);
            resolve(false);
          }
        );
      }
    });
    return promise;
  };

  private IRootModule_IsRootedWithBusyBox = async (): Promise<boolean> => {
    /*android*/
    const promise = new Promise<boolean>((resolve, reject) => {
      if (!this.IRootModule) {
        console.error('IRootModule_IsRootedWithBusyBox - Module not found.');
        resolve(false);
      } else {
        this.IRootModule.isRootedWithBusyBox(
          (res: boolean) => {
            if (res === true) {
              console.error('IRootModule_IsRootedWithBusyBox - Rooting detected');
            }
            resolve(res);
          },
          (err: string) => {
            console.error(`IRootModule_IsRootedWithBusyBox - ${err || ''}`);
            resolve(false);
          }
        );
      }
    });
    return promise;
  };

  private DiagnosticsModule_IsDeviceRooted = async (): Promise<boolean> => {
    /*android*/
    const promise = new Promise<boolean>((resolve, reject) => {
      if (!this.DiagnosticsModule) {
        console.error('DiagnosticsModule_IsDeviceRooted - Module not found.');
        resolve(false);
      } else {
        this.DiagnosticsModule.isDeviceRooted(
          (res: boolean) => {
            if (res === true) {
              console.error('DiagnosticsModule_IsDeviceRooted - Rooting detected');
            }
            resolve(res);
          },
          (err: string) => {
            console.error(`DiagnosticsModule_IsDeviceRooted - ${err || ''}`);
            resolve(false);
          }
        );
      }
    });
    return promise;
  };

  private checkingForAntiTampering = async (): Promise<boolean> => {
    //TODO: https://www.npmjs.com/package/cordova-plugin-antitampering
    const promise = new Promise<boolean>((resolve, reject) => {
      resolve(false);
    });
    return promise;
  };

  private checkingForRooting = async (): Promise<boolean> => {
    const isRooted = {
      RootModule: await this.IRootModule_IsRootedWithBusyBox(),
      DiagnosticsModule: await this.DiagnosticsModule_IsDeviceRooted(),
    };
    const promise = new Promise<boolean>((resolve, reject) => {
      resolve(isRooted.RootModule && isRooted.DiagnosticsModule);
    });
    return promise;
  };

  private checkingForJailbreak = async (): Promise<boolean> => {
    const isRooted = await this.IRootModule_IsRooted();
    const promise = new Promise<boolean>((resolve, reject) => {
      resolve(isRooted);
    });
    return promise;
  };

  public StartupControl = async (): Promise<boolean> => {
    return (
      (this.checkForAntiTampering && (await this.checkingForAntiTampering())) ||
      (this.checkForRooting && (await this.checkingForRooting())) ||
      (this.checkForJailbreak && (await this.checkingForJailbreak()))
    );
  };

  public PageChangeControl = async (): Promise<boolean> => {
    return this.checkForAntiTampering && (await this.checkingForAntiTampering());
  };
}
